import React, { Fragment } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';

import "./SafetyAppPreview.css"

const SafetyAppPreview = (props) => {

    const showVar = (str) => {
        return !str ? <>&nbsp;</> : str;
    }

    const checklistItems = [
        { title: 'Hand Injury', methods: `Wear correct gloves. Guards are in place. Use proper tools. Identify pinch points and sharp edges.`, id: 'handInjury' },
        { title: 'Fall Hazard', methods: `Inspect fall protection prior to use. Wear full body harness w/double locking shock absorbing lanyard. Ensure adequate anchor point. Ensure guard rail system is adequate. Proper ladder set up and use.`, id: 'fallHazard' },
        { title: 'Eye Injury', methods: `Safety Glasses, Update to Face Shield/Chemical Goggles or combination, when needed.`, id: 'eyeInjury' },
        { title: 'Foot Injury', methods: `Proper attire being worn? (Sturdy work shoes, steel toed shoes if needed, etc.). (Safety toed boots required on MILCON projects)`, id: 'footInjury' },
        { title: 'Sprains or Strains', methods: `Proper lifting techniques, Use lifting/carrying devices. Ensure rigging has been inspected. Use Buddy system.`, id: 'sprainsOrStrains' },
        { title: 'Struck By', methods: `Hard hats. Hi visibility vest. Back up alarms on equipment. Stay clear of overhead loads.`, id: 'struckBy' },
        { title: 'Head Injury', methods: `Identify low hanging objects with tape/tags. Wear proper head protection.`, id: 'headInjury' },
        { title: 'Excessive Noise', methods: `Wear appropriate hearing protection, (ear plugs, muffs or combination).`, id: 'excessiveNoise' },
        { title: 'Heat/Cold Stress', methods: `(Heat) Drink plenty of fluids. (Cold) Ensure adequate clothing. Limit exposure times.`, id: 'heatColdStress' },
        { title: 'Slippery Surfaces, Tripping Hazards', methods: `Identify all trip hazards and slip hazards. Good housekeeping, keep debris, cords, material clear of access and egress. Keep work area clean.`, id: 'slipperySurfacesTrippingHazards' },
        { title: 'Hot work - Any flame or spark producing work', methods: `Wear protective gloves, face shield and/or heat suits, as needed. Apply proper barriers for protection against heat sources.`, id: 'hotWork' },
        { title: 'Respiratory Hazard', methods: `If possible, ventilate area to eliminate hazards. Determine proper respirator required for hazard(s).`, id: 'resperatoryHazard' },
        { title: 'Electrical Hazard', methods: `Use GFCI, low voltage lighting. Ensure proper grounding of equipment. Inspect cords prior to use. ENSURE Lock out Tag out . Identify existing overhead or underground power lines.`, id: 'electricalHazard' },
        { title: 'Confined Space Entry', methods: `Identify ALL hazards of space. Determine if confined space permit is required. Ventilate as needed. Verify proper egress.`, id: 'confinedSpaceEntry' },
        { title: 'Skin Contact', methods: `Review product MSDS or SDS wear PPE accordingly.`, id: 'skinContact' },
        { title: 'Stored Energy LO/TO', methods: `Verify isolation of energy source with authorized personnel before beginning work. Ensure affected personal are notified.`, id: 'storedEnergyLOTO' },
        { title: 'Caught in Between Excavations, equipment, material', methods: `Bench Slope, Shore trench or excavation. Keep body parts clear of loads and material. Lock out and Tag out equipment during maintenance.`, id: 'caughtInBetween' },
    ]

    const hazardAssessmentItems = [
        { title: 'Have all personnel received all required site-specific training and on site orientation? (If no, stop and take action)', id: 'personnelTraining' },
        { title: 'Has equipment been inspected prior to use?', id: 'equipmentInspected' },
        { title: 'Is Crew familiar with evacuation routes?', id: 'crewEvacuation' },
        { title: 'Overhead or underground utilities present?', id: 'utilitiesPresent' },
        { title: 'If using devices such as ladders, forklifts, JLG or scissor lifts have the operators been properly trained? (If not, stop and take proper action.)', id: 'deviceTraining' },
        { title: 'Has the construction area been properly barricaded and signs posted where required? (If not stop and take action)', id: 'areaBarricaded' },
        { title: 'Have all necessary licenses, certificates and or proper training to complete the job been obtained? (If not stop and take action)', id: 'licensesAndCertificates' },
        { title: 'Work area - Could other trades present hazards?', id: 'workArea' },
    ]

    return (
        <div id="">
            <div id="safetyAppPreviewContainer">
                <Container fluid>
                    <Row className='my-2 mx-0 text-end'>
                        <Col className="p-0">
                            <Button onClick={showVar(props.hidePreview)} color="secondary">Close</Button>
                        </Col>
                    </Row>
                </Container>
                <table className='w-100'>
                    <tr>
                        <td width="50%" colSpan={2}><label>Job Site</label>
                            <input disabled name="jobSite" value={props.jobSite || ''} />
                        </td>
                        <td colSpan="2"><label>Date</label>
                            <input disabled name="datePrepared" type="date" value={props.datePrepared || ''} />
                        </td>
                    </tr>
                    <tr>
                        <td width="50%" colSpan={2}><label>Company Name</label>
                            <input disabled name="companyName" value={props.companyName || ''} />
                        </td>
                        <td colSpan="2"><label>Supervisor Name</label>
                            <input disabled name="supervisorName" value={props.supervisorName || ''} />
                        </td>
                    </tr>
                    <tr>
                        <td width="50%" colSpan={2}><label>Job Description</label>
                            <input disabled name="jobDescription" value={props.jobDescription || ''} />
                        </td>
                        <td colSpan="2"><label>Number of Revisions</label>
                            <input disabled name="numberOfRevisions" value={props.numberOfRevisions || ''} />
                        </td>
                    </tr>
                    <tr>
                        <td width="25%"><label>Submitted By</label>
                            <input disabled name="user" value={props.user || ''} />
                        </td>
                        <td width="25%"><label>Email</label>
                            <input disabled name="email" value={props.email || ''} />
                        </td>
                        <td colSpan="2"><label>Job #</label>
                            <input disabled name="jobNumber" value={props.jobNumber || ''} />
                        </td>
                    </tr>
                </table>

                <table className='w-100'>
                    <tr>
                        <th width="40%" colSpan={3}>
                            Potential Hazards
                        </th>
                        <th>
                            Methods to Control/Eliminate Hazard Identified
                        </th>
                    </tr>
                    {checklistItems.map((row, rowIndex) => (
                        <Fragment key={rowIndex}>
                            <tr>
                                <td rowSpan="2" width="20%" className='p-1'>{row.title}</td>
                                <td rowSpan="2" width="10%" className='p-1 text-center text-large'>{props[`checklist-radio_${row.id}`] === 'Y' && 'Y'}</td>
                                <td rowSpan="2" width="10%" className='p-1 text-center text-large'>{props[`checklist-radio_${row.id}`] === 'N' && 'N'}</td>
                                <td className='p-1'><em>{row.methods}</em></td>
                            </tr>
                            <tr>
                                <td className='p-1'>{props[`checklist-task_${row.id}`] || <>&nbsp;</>}</td>
                            </tr>
                        </Fragment>
                    ))}
                </table>

                <table className='w-100'>
                    <tr>
                        <th colSpan={3} className='text-danger'>Add any additional Tasks, Hazards, and Controls not previously listed (Cranes, Scaffolds, etc..)</th>
                    </tr>
                    <tr>
                        <th width="33%">
                            Describe Today's Tasks (Each Step)
                        </th>
                        <th width="33%">
                            Identify Potential Hazards
                        </th>
                        <th width="33%">
                            Ways to Eliminate/Control Hazards
                        </th>
                    </tr>
                    {new Array(7).fill(null)
                        .map((item, index) => {
                            if (!(props[`task-description_${index + 1}`] || props[`task-hazard_${index + 1}`] || props[`task-solution_${index + 1}`])) return;
                            return (<tr key={index} className='m-0'>
                                <td className='p-0 border border-secondary '>
                                    <input disabled name={`task-description_${index + 1}`} value={props[`task-description_${index + 1}`] || ''} />
                                </td>
                                <td className='p-0 border border-secondary '>
                                    <input disabled name={`task-hazard_${index + 1}`} value={props[`task-hazard_${index + 1}`] || ''} />
                                </td>
                                <td className='p-0 border border-secondary '>
                                    <input disabled name={`task-solution_${index + 1}`} value={props[`task-solution_${index + 1}`] || ''} />
                                </td>
                            </tr>)
                        })}
                </table>

                <table className='w-100'>
                    <tr>
                        <th width="70%">
                            Additional Hazard Assessments
                        </th>
                        <th width="10%">
                            Yes
                        </th>
                        <th width="10%">
                            No
                        </th>
                        <th width="10%">
                            N/A
                        </th>
                    </tr>
                    {hazardAssessmentItems.map((row, rowIndex) => (
                        <Fragment key={rowIndex}>
                            <tr>
                                <td className='p-1'>{row.title}</td>
                                <td className='p-1 text-center text-large'>{props[`hazard-radio_${row.id}`] === 'Y' && 'Y'}</td>
                                <td className='p-1 text-center text-large'>{props[`hazard-radio_${row.id}`] === 'N' && 'N'}</td>
                                <td className='p-1 text-center text-large'>{props[`hazard-radio_${row.id}`] === 'NA' && 'N/A'}</td>
                            </tr>
                        </Fragment>
                    ))}
                </table>

                <table className='w-100'>
                    <tr>
                        <th width="50%">
                            Name
                        </th>
                        <th width="50%">
                            Name
                        </th>
                    </tr>
                    {new Array(14).fill(null).map((item, index) => {
                        if (!props[`name_${(index * 2) + 1}`] && !props[`name_${(index * 2) + 2}`]) return;
                        return (<tr key={index} className='p-0 border border-secondary '>
                            {/* <td>
                                <input disabled name={`name_${(index * 2) + 1}`} value={props[`name_${(index * 2) + 1}`] || ''} />
                            </td>
                            <td>
                                <input disabled name={`name_${(index * 2) + 2}`} value={props[`name_${(index * 2) + 2}`] || ''} />
                            </td> */}
                            <td>
                                {props[`name_${(index * 2) + 1}`] &&
                                    <img className="signatureNamesPreview" src={props[`name_${(index * 2) + 1}`]} alt="Signature" />}
                            </td>
                            <td>
                                {props[`name_${(index * 2) + 2}`] &&
                                    <img className="signatureNamesPreview" src={props[`name_${(index * 2) + 2}`]} alt="Signature" />}
                            </td>
                        </tr>)
                    })}
                </table>
            </div>

        </div>

    )
}

export default SafetyAppPreview;